import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationOnixPage } from "~/pages/settings/organisations/organisation/onix/organisation-onix-page";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/onix-upload/",
)({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.onixUploads") }],
  }),
  component: OrganisationOnixPage,
});
